export default "__VITE_ASSET__L4ynK8lK__"